<div class="modal fade politicas-modal" tabindex="-1" id="politicasModal">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
    >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ title === 'P' ? 'Políticas tratamiento de datos personales' :
          title=== 'T' ? 'Términos y condiciones' : 'Consulta y reporte a centrales de riesgos' }}
        </h5>
      </div>
      <div class="modal-body text-start" id="modal">
        @if (title === 'R') {
          <div class="form-check">
            <p class="sub-title">
              <strong>
                Autorización consulta y reporte a centrales de riesgo para acceder a los servicios de neocrédito.
              </strong>
            </p>
            Autorizo de manera expresa e irrevocable a Bancóldex o a quien represente sus derechos, y/o a los Aliados<sup
            id="ref_0"><a href="#nota_0" (click)="scrollToAnchor('nota_0', $event)">1</a></sup>, para que
            consulten, procesen o soliciten o divulguen información crediticia ante TransUnion, Datacredito y/o a cualquier otro
            operador y/o fuente de información legalmente establecido. Igualmente, autorizo de manera expresa e irrevocable a
            Bancóldex o a quien represente sus derechos para que comparta con el Aliado que haya suscrito con esta entidad el
            Contrato para Vinculación a neocrédito, toda la información referente a mi comportamiento como cliente, proveedor o
            contraparte que se relacione con el nacimiento, ejecución, modificación, liquidación y/o extinción de obligaciones
            directas o indirectas contraídas por mí con anterioridad, o que llegue a contraer con el sector financiero o real,
            producto de aperturas de crédito, préstamos, servicios financieros, cobranzas, contratos, actos, así como cualquier
            otra relación financiera, comercial, bursátil, o proceso con Bancóldex y/o sus filiales, de conformidad con la
            normatividad vigente sobre la materia. La permanencia de la información estará sujeta a los principios, términos y
            condiciones consagrados en la Ley 1266 de 2008, de Colombia, y demás normas que la modifiquen, aclaren o reglamenten.
            <br><br>
            Así mismo, autorizo expresa e irrevocablemente a Bancóldex o quien represente sus derechos, y/o a los Aliados, para
            que consulten toda la información financiera, crediticia, comercial, de servicios, bursátil y la proveniente de otros
            países, atinente a mis relaciones con el sistema financiero, comercial, bursátil y de servicios, o de cualquier sector
            en cualquier tiempo.
            <br><br>
            Declaro haber leído y entendido, las anteriores condiciones y autorizo a Bancoldex y/o a los Aliados a realizar las
            gestiones allí indicadas.
            <br />
            <br />
            <hr style="width: 50%;">
            <ol class="list">
              <li id="nota_0"><a href="#ref_0" (click)="scrollToAnchor('ref_0', $event)">↑</a> La lista actualizada de Aliados puede ser consultada en: <a class="btn-link" style="cursor: pointer;" title="Seguir enlace"
              (click)="_modal.enlaceModal('https://neocredito.bancoldex.com/neocredito/home')">https://neocredito.bancoldex.com/neocredito/home
            </a></li>
          </ol>
        </div>
      }
      @if (title === 'P') {
        <div>
          De conformidad con lo establecido en las normas que regulan el derecho a la protección de datos personales en Colombia y
          la Política de Tratamiento de Datos Personales del Banco de Comercio Exterior de Colombia S.A. que puede ser consultada
          en:
          <br />
          <br />
          <a class="btn-link" style="cursor: pointer;" title="Seguir enlace"
            (click)="_modal.enlaceModal('https://www.bancoldex.com/es/politica_tratamientos_datos_bx')">
            https://www.bancoldex.com/es/politica_tratamientos_datos_bx
          </a>
          <br />
          <br />
          Autorizo de manera previa, expresa e informada a Bancóldex para consultar, recolectar, almacenar, usar, circular, compartir, transmitir o suprimir mis datos personales y financieros, para:
          <br />
          <br />
          <ol class="list " type="I">
            <li>
              Acceder a los servicios de neocrédito y, particularmente, para transferirla al Aliado<sup id="ref_0"><a href="#nota_0" (click)="scrollToAnchor('nota_0', $event)">1</a></sup> con el objeto de que éste analice la información entregada, para decidir o no presentar una Oferta de Crédito.
            </li>
            <li>
              Compartirla con entidades o programas del gobierno colombiano con los cuales Bancóldex tenga una relación contractual y que sea entregada para el desarrollo de actividades correspondientes al cumplimiento de su objeto.
            </li>
            <li>
              Enviarme información y ser contactado directamente por Bancóldex, por sus Aliados o por las entidades o programas del gobierno.
            </li>
            <li>
              Poner a disposición de las autoridades competentes la información requerida por estas.
            </li>
          </ol>
          <br />
          En caso de aceptación de una Oferta de Crédito, el Aliado será responsable del tratamiento de mis datos personales y financieros.
          <br />
          La presente autorización la otorgo hasta el momento en el que exprese a Bancóldex su revocatoria, por cualquiera de los canales dispuestos para tal fin
          <br />
          <br />
          Declaro haber leído y entendido y autorizo a Bancóldex el Tratamiento de Datos Personales.
          <br/>
          <br/>
          <br/>
          <hr style="width: 50%;">
          <ol class="list">
            <li id="nota_0"><a href="#ref_0" (click)="scrollToAnchor('ref_0', $event)">↑</a> La lista actualizada de Aliados puede ser consultada en: <a
            class="btn-link" style="cursor: pointer;" title="Seguir enlace"
            (click)="_modal.enlaceModal('https://neocredito.bancoldex.com/neocredito/home')">
            https://neocredito.bancoldex.com/neocredito/home
          </a></li>
        </ol>
      </div>
    }
    @if (title === 'T') {
      <div>
        Lo invitamos a leer estos Términos y Condiciones y aceptarlos antes de
        iniciar la exploración o uso del Sitio Web.
        <p class="sub-title"><strong>Definiciones</strong></p>
        Por favor tener en cuenta las siguientes definiciones de algunos
        términos usados reiterativamente en el documento:<br />
        <br />
        Bancóldex: es el Banco de Comercio Exterior de Colombia S.A. identificado con NIT 800.149.923-6.<br />
        <br />
        Contrato para Vinculación neocrédito: es el contrato suscrito entre Bancóldex y las entidades financieras vigiladas por
        la Superintendencia Financiera, las entidades orientadas al crédito microempresarial y las fintech que se encuentren
        registradas en el Sitio Web y que tiene por objeto definir los términos y condiciones que deben ser cumplidos por el
        Aliado para la vinculación y uso del Sitio Web, así como los derechos y obligaciones de las partes.<br />
        <br />
        Aliado(s): son las entidades que tengan suscrito con Bancóldex el Contrato Marco para la Utilización de Líneas de
        Crédito y Servicios Financieros Ofrecidos por Bancóldex, el Contrato para la vinculación a neocrédito y, que se
        encuentren registradas en el Sitio Web. <br />
        <br />
        Microempresario: son las personas naturales o jurídicas que se registran en el Sitio Web a fin de acceder a los
        servicios que ofrece neocrédito. <br />
        <br />
        neocrédito: es una plataforma digital desarrollada por Bancóldex y alojada en un sitio web, que permite la interacción
        entre oferentes y demandantes de crédito. Las operaciones de crédito que resulten de esta interacción se formalizarán
        fuera de la plataforma, es decir, de manera directa entre Aliados y Microempresarios.<br />
        <br />
        Oferta de Crédito: es el crédito aprobado por el Aliado al Microempresario, el cual no podrá ser revocado sin
        justa causa, una vez aceptado por el Microempresario a través de neocrédito.<br />
        <br />
        Sitio Web:
        <a class="btn-link" style="cursor: pointer;" title="Seguir enlace"
          (click)="_modal.enlaceModal('https://neocredito.bancoldex.com/neocredito')"
        >www.neocredito.bancoldex.com</a><br />
        <br />
        Solicitud de Crédito: es la solicitud de crédito que hacen los Microempresarios a través de neocrédito.
        <p class="sub-title"><strong>Funcionamiento de neocrédito</strong></p>
        Previa autorización para el tratamiento de datos otorgada por el Microempresario en el Sitio Web, la información cargada
        por el Microempresario en el Sitio Web es compartida por Bancóldex con los Aliados, quienes la analizan y, a
        partir de ello, hacen una Oferta de Crédito al Microempresario.
        <br />
        El uso del Sitio Web proporcionado por Bancóldex no garantiza al Microempresario la aprobación del crédito solicitado,
        ni al Aliado que el Microempresario tome el crédito aprobado. En este sentido, la obligación de Bancóldex es de
        medio y no de resultado.
        <p class="sub-title"><strong>Disponibilidad del servicio</strong></p>
        El acceso al Sitio Web permanentemente estará disponible para el Microempresario salvo que existan circunstancias de
        fuerza mayor, caso fortuito o hechos de un tercero que impidan o restrinjan dicho acceso.<br />
        <br />
        Bancóldex se reserva el derecho de modificar o suprimir los contenidos del Sitio Web sin necesidad de previo aviso. En
        todo caso, las modificaciones, actualizaciones o eliminaciones, serán informadas a través del mismo medio con el fin de
        que los Microempresarios estén plenamente informados de los cambios realizados.
        <p class="sub-title">
          <strong>Vínculos con otros sitios en Internet</strong>
        </p>
        Bancóldex facilita a los Microempresarios la posibilidad de escoger una Oferta de Crédito entre las ofertas entregadas
        por los Aliados.<br />
        <br />
        Aceptada una Oferta de Crédito por el Microempresario, el proceso de formalización y desembolso deberá realizarse
        directamente a través de los canales que el Aliado tenga habilitados para ello dentro de los cuales se incluye su
        propio sitio web, líneas telefónicas, oficinas o cualquier otro canal dispuesto por el Aliado. <br />
        <br />
        Bancóldex pone a disposición el Sitio Web para que el Microempresario elija el crédito que mejor se acomode a sus
        necesidades. Atendiendo esto, Bancóldex no asume responsabilidad en caso de que el Microempresario no reciba ofertas de
        crédito. <br />
        <br />
        Cualquier transacción que el Microempresario lleve a cabo con los Aliados se realiza única y exclusivamente entre
        el Microempresario y el Aliado, bajo su propia responsabilidad. Los sitios vinculados al Sitio Web no están
        controlados por Bancóldex, razón por la cual, este no es responsable de estos sitios. <br />
        <br />
        El Microempresario entiende y acepta que, a partir de la aceptación de la Oferta de Crédito, debe cumplir con todas las
        políticas y procedimientos para el otorgamiento de crédito definidos por el Aliado.
        <p class="sub-title"><strong>Derecho de propiedad</strong></p>
        El Sitio Web está protegido por derechos de autor, marcas, patentes, o formas diferentes del derecho de propiedad. Dicho
        contenido incluye, entre otros, los textos, el software, la música, el sonido, las fotografías, los videos, los
        gráficos, etc. Por lo tanto, el Microempresario deberá abstenerse de publicar, retransmitir o comercializar a cualquier
        título o por cualquier medio, total o parcialmente, tanto la información contenida en el Sitio Web, como en sus enlaces,
        so pena de incurrir en las responsabilidades por violación de los derechos de autor, conforme a las normas vigentes.
        <p class="sub-title">
          <strong
            >Características del equipo para la óptima navegación</strong
            >
          </p>
          Para asegurar una correcta visualización de nuestro Sitio Web se recomienda utilizar los navegadores Microsoft Edge 91,
          Firefox 90, Chrome 92 o superior.
          <p class="sub-title"><strong>Seguridad</strong></p>
          El Sitio Web cuenta con los procedimientos electrónicos para proteger y ayudar a prevenir el acceso no autorizado,
          evitar la pérdida, mal uso, alteración, acceso no autorizado y hurto de los datos personales.
          <br />
          El Microempresario será responsable de los daños y perjuicios que pueda causar a Bancóldex o a cualquier tercero por los
          usos indebidos del Sitio Web. <br />
          <br />
          De acuerdo con lo informado previamente, el Microempresario autoriza y declara lo siguiente:
          <p class="sub-title"><strong>Declaraciones:</strong></p>
          El Microempresario declara que:
          <ol class="list">
            <li>Bancóldex es propietario del Sitio Web.</li>
            <li>Conoce la mecánica de operación de neocrédito.</li>
            <li>
              Conoce y acepta que Bancóldex no es la entidad que evalúa y aprueba las operaciones de crédito y que, en caso de ser
              aprobada una Oferta de Crédito, la formalización de la operación se hará directamente con el Aliado.
            </li>
            <li>
              La información cargada al Sitio Web es completa, cierta, verificable y no contiene falsedades. En caso de que
              Bancóldex conozca de la posible comisión de algún delito haciendo uso de su Sitio Web, de tal situación pondrá en
              conocimiento a las autoridades.
            </li>
            <li>
              Conoce y acepta que el sitio puede presentar indisponibilidades temporales no imputables a Bancóldex.
            </li>
            <li>
              Conoce que el Sitio Web no ofrece transaccionalidad de ninguna clase y en el mismo no se realiza transferencias de recursos.
            </li>
            <li>
              Se hace responsable del manejo de los Microempresarios y contraseñas que le sean autorizados para el acceso y gestión en
              el Sitio Web.
            </li>
            <li>
              Conoce que los plazos incluidos en las diferentes etapas del proceso de neocrédito son indicativos, por lo que en
              caso de no cumplirse alguno, tal situación no implica ningún tipo de responsabilidad para Bancóldex.
            </li>
            <li>
              Mantendrá la confidencialidad de la información a la que acceda con ocasión del uso del Sitio Web.
            </li>
            <li>
              Conoce que en caso de aceptar una Oferta de Crédito de un Aliado no vigilado por la Superintendencia Financiera, no tendrán aplicación las normas sobre consumidor financiero.
            </li>
            <li>
              El origen y destino de sus recursos es lícito y no contraviene el ordenamiento jurídico colombiano.
            </li>
            <li>
              No se encuentra reportado en ninguna de las listas internacionales vinculantes para Colombia en temas de lavado de
              activos, financiación del terrorismo y/o proliferación de armas de destrucción masiva, y así mismo no se encuentra
              condenado por la comisión de actividades involucradas con los anteriores delitos.
            </li>
            <li>
              En caso de incumplimiento de las declaraciones 11 y 12, no podrá continuar utilizando neocrédito.
            </li>
          </ol>
          <p class="sub-title">
            <strong>Ley y Jurisdicción aplicables</strong>
          </p>
          Las políticas y condiciones de acceso y uso aquí establecidas y los conflictos que puedan surgir respecto de su
          interpretación, uso, alcance y terminación se rigen por la ley Colombiana y se someten a los jueces y tribunales
          colombianos.<br />
          <ul class="list">
            <li>
              Declaro haber leído entendido los Términos y Condiciones para el uso del Sitio Web y de neocrédito, por lo que los acepto.
            </li>
            <!-- <li>
            Declaro haber leído y entendido la Política de Tratamiento de Datos Personales del Banco de
            Comercio Exterior de Colombia S.A. publicada en:
            <a
              href="https://www.bancoldex.com/es/politica_tratamientos_datos_bx">
              https://www.bancoldex.com/es/politica_tratamientos_datos_bx
            </a>
          </li> -->
        </ul>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="politicas-modal__btn-salir" data-bs-dismiss="modal">
      Salir
    </button>
    <button
      id="btn-modal"
      type="button"
      class="politicas-modal__btn-aceptar"
      (click)="closeModal()"
      >
      Aceptar
    </button>
  </div>
</div>
</div>
</div>
